import { render, staticRenderFns } from "./clinic-reseter.vue?vue&type=template&id=465e16aa&scoped=true"
import script from "./clinic-reseter.vue?vue&type=script&lang=js"
export * from "./clinic-reseter.vue?vue&type=script&lang=js"
import style0 from "./clinic-reseter.vue?vue&type=style&index=0&id=465e16aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465e16aa",
  null
  
)

export default component.exports